import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutLogosQuoteDivider = {
  factory: EElement({
    id: '5cc971d4-4876-aca3-ef3a-9e065e7347e8',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('1fd35265-9f7f-7e2a-e5b5-630e08791bd5')]),
      children: EList([
        EElement({
          id: '5cc971d4-4876-aca3-ef3a-9e065e7347e9',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'f61a4206-08fc-1c95-381a-9549b35b3c9d',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('b20d31c3-fb88-d10e-9f56-6399b14d6223'),
                  ]),
                  children: EList([
                    EElement({
                      id: '873fc508-fdb1-af9e-754b-c573ba128abd',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('6d631d5c-8e3e-539c-f25d-49d110f62018'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'cab80213-4e29-897c-df4d-01635903b98a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              children: EList([
                                EElement({
                                  id: 'cab80213-4e29-897c-df4d-01635903b98b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Aliquet consectetur'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '4ab34a96-edd7-d71f-fed4-6f4a8f54c2fe',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('43bd4474-aedb-7dc8-b000-fe820e1d3b0c'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '4ab34a96-edd7-d71f-fed4-6f4a8f54c2ff',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Aliquet consectetur id magna ac integer.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '58c609d1-df6e-73e9-4f2a-72498699bd3a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('864045c1-6c7c-a271-82e1-8b7ac90caccf'),
                              ]),
                              children: EList([]),
                            }),
                          }),
                          EElement({
                            id: '2c5b52ad-8d57-1384-ddcd-38d7cc1be804',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('54eef58b-c367-38bb-7b13-fe77a5df05be'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '2c5b52ad-8d57-1384-ddcd-38d7cc1be805',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageCards),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6273081d9b64a79939744228"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '4e99ed88-910f-dd8c-a678-d046d4ea30a9'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '2c5b52ad-8d57-1384-ddcd-38d7cc1be806',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    children: EList([
                                      EElement({
                                        id: '2c5b52ad-8d57-1384-ddcd-38d7cc1be807',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Full Name, Title'),
                                      }),
                                      EElement({
                                        id: '2c5b52ad-8d57-1384-ddcd-38d7cc1be808',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('LineBreak')
                                        ),
                                        data: ERecord({}),
                                      }),
                                      EElement({
                                        id: '2c5b52ad-8d57-1384-ddcd-38d7cc1be809',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Company'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'f61a4206-08fc-1c95-381a-9549b35b3ca7',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('c70f2bf7-3213-d366-badb-afa71983ae44'),
                        ]),
                        children: EList([
                          EElement({
                            id: '840c4579-ea2c-c8fd-7d83-5d0f307b5484',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.ephicientLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('Ephicient logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6273081d9b64a79939744254"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '35a7463a-ab5a-459d-9d3f-31ba2f81df9e',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.twentyLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('OE logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6273081d9b64a79939744259"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'cb8b2a0b-a1aa-fdee-5e00-508eb8a5582d',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.pipelinxLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('2020INC logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6273081d9b64a79939744255"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '36bbcee5-d646-b02d-97b7-ac3ef6254ef7',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.oeLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('The Paak logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                  medium: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6273081d9b64a79939744248"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '638c2e93-3d5b-a2fe-b2fb-1c20a5ba2ec4',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.thePaakLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('Pipelinx.co logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6273081d9b64a79939744258"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '9cbc5dca-b0de-eb5d-d021-deea87f6e980',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.ariseHealthLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('AriseHealth logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6273081d9b64a7993974424a"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '1fd35265-9f7f-7e2a-e5b5-630e08791bd5',
      type: 'class',
      name: 'Logos Quote Divider',
      comb: '',
      styleLess:
        'position: relative; padding-top: 60px; padding-right: 30px; padding-bottom: 60px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'b20d31c3-fb88-d10e-9f56-6399b14d6223',
      type: 'class',
      name: 'Clients Wrapper Two',
      comb: '',
      styleLess:
        'display: flex; max-width: 820px; margin-right: auto; margin-left: auto; justify-content: space-between; align-items: center;',
      children: [],
      variants: {small: {styleLess: 'flex-direction: column;'}},
    },
    {
      _id: '6d631d5c-8e3e-539c-f25d-49d110f62018',
      type: 'class',
      name: 'Clients Info Two',
      comb: '',
      styleLess:
        'display: flex; max-width: 350px; flex-direction: column; align-items: flex-start;',
      children: [],
      variants: {small: {styleLess: 'max-width: none; margin-bottom: 40px;'}},
    },
    {
      _id: '43bd4474-aedb-7dc8-b000-fe820e1d3b0c',
      type: 'class',
      name: 'Clients Quote Two',
      comb: '',
      styleLess:
        'margin-top: 10px; font-size: 32px; line-height: 40px; font-weight: 600;',
      children: [],
      variants: {
        medium: {styleLess: 'font-size: 28px; line-height: 36px;'},
        tiny: {styleLess: 'font-size: 24px; line-height: 32px;'},
      },
    },
    {
      _id: '864045c1-6c7c-a271-82e1-8b7ac90caccf',
      type: 'class',
      name: 'Clients Divider',
      comb: '',
      styleLess:
        'width: 90%; height: 1px; margin-top: 20px; margin-bottom: 20px; background-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {},
    },
    {
      _id: '54eef58b-c367-38bb-7b13-fe77a5df05be',
      type: 'class',
      name: 'Clients Info',
      comb: '',
      styleLess:
        'display: flex; align-items: center; font-size: 14px; line-height: 20px;',
      children: [],
      variants: {},
    },
    {
      _id: '4e99ed88-910f-dd8c-a678-d046d4ea30a9',
      type: 'class',
      name: 'Clients Info Image',
      comb: '',
      styleLess:
        'width: 50px; height: 50px; margin-right: 24px; object-fit: cover;',
      children: [],
      variants: {tiny: {styleLess: 'margin-right: 16px;'}},
    },
    {
      _id: 'c70f2bf7-3213-d366-badb-afa71983ae44',
      type: 'class',
      name: 'Clients Grid',
      comb: '',
      styleLess:
        'display: grid; justify-items: center; align-items: center; grid-auto-columns: 1fr; grid-column-gap: 50px; grid-row-gap: 50px; grid-template-columns: 1fr 1fr; grid-template-rows: auto auto;',
      children: [],
      variants: {
        small: {
          styleLess:
            'margin-top: 15px; grid-column-gap: 40px; grid-template-columns: 1fr 1fr 1fr;',
        },
        tiny: {
          styleLess:
            'grid-column-gap: 20px; grid-row-gap: 40px; grid-template-columns: 1fr 1fr;',
        },
      },
    },
    {
      _id: '96521aa5-d56e-644a-ce5e-e9732f052992',
      type: 'class',
      name: 'Clients Image Two',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
  ],
} as const;
